import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { VISIBLE_CATEGORIES, ACTIVE_BRANDS } from "@/data/catalog";
import { POLICY_NAV } from "@/data/policies";
import { SITE } from "@/data/site";

function Column({ title, children }) {
  return (
    <div>
      <h3 className="mb-3 text-xs font-bold uppercase tracking-widest text-slate-400">{title}</h3>
      <ul className="space-y-2 text-sm">{children}</ul>
    </div>
  );
}

const linkClass = "text-slate-300 transition-colors duration-200 hover:text-white";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-white">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <img src="/logo.png" alt="CA HVAC Direct" className="h-11 w-11 object-contain" />
              <span>
                <span className="block font-heading text-lg font-black tracking-tight">CA HVAC DIRECT</span>
                <span className="block text-[10px] uppercase tracking-widest text-slate-400">California HVAC Direct</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-slate-400">HVAC equipment direct from established manufacturers — for homeowners and trade customers.</p>
            <div className="mt-5 space-y-2 text-sm">
              <a href={SITE.phoneHref} className={`inline-flex items-center gap-2 ${linkClass}`} data-testid="footer-phone"><Phone className="h-4 w-4 text-sky-400" />{SITE.phone}</a>
              <br />
              <a href={SITE.emailHref} className={`inline-flex items-center gap-2 ${linkClass}`} data-testid="footer-email"><Mail className="h-4 w-4 text-sky-400" />{SITE.email}</a>
            </div>
          </div>

          <Column title="Shop">
            <li><Link to="/shop" className={linkClass}>All Equipment</Link></li>
            {VISIBLE_CATEGORIES.slice(0, 6).map((c) => (
              <li key={c.slug}><Link to={`/category/${c.slug}`} className={linkClass}>{c.name}</Link></li>
            ))}
          </Column>

          <Column title="Brands">
            {ACTIVE_BRANDS.map((b) => (
              <li key={b.slug}><Link to={`/brand/${b.slug}`} className={linkClass}>{b.name}</Link></li>
            ))}
          </Column>

          <Column title="Company">
            <li><Link to="/support" className={linkClass}>Support / FAQ</Link></li>
            <li><Link to="/about" className={linkClass}>About</Link></li>
            <li><Link to="/contact" className={linkClass}>Contact</Link></li>
          </Column>

          <Column title="Policies">
            {POLICY_NAV.map((p) => (
              <li key={p.slug}><Link to={`/policies/${p.slug}`} className={linkClass}>{p.title}</Link></li>
            ))}
          </Column>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-slate-800 pt-6 text-xs text-slate-400 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} California HVAC Direct. All rights reserved.</p>
          


        </div>
      </div>
    </footer>
  );
}
